import type { Feature, Point } from "geojson";
import type { BehaviorSubject } from "rxjs";
import type { CircleLayerSpecification, Map } from "@iventis/mapbox-gl";
import { MapState } from "../../types/store-schema";
import { MapboxLocalLayer } from "./mapbox-local-layer";
import { ModelStandBaseLayer } from "../generic-layers/model-stand-base-layer";
import { iventisPointToBaseSublayer } from "../mapbox/engine-mapbox-helpers";

export class MapboxModelStandBaseLayer extends ModelStandBaseLayer {
    private readonly mapboxLayer: MapboxLocalLayer<Feature<Point>[], CircleLayerSpecification>;

    private readonly baseLayerId: string;

    private readonly metadata: { type: "stand-base"; name: string };

    constructor(state$: BehaviorSubject<MapState>, modelId: string, map: Map, metadata: { type: "stand-base"; name: string }) {
        super(state$, modelId);
        this.metadata = metadata;
        this.baseLayerId = modelId;
        this.mapboxLayer = new MapboxLocalLayer(map, this.layerId, this.sourceId);
        this.addLocalSource();
        this.addLayer();
    }

    protected addLayer(): void {
        const mapboxLayer = iventisPointToBaseSublayer(this.baseLayer, this.layerId, undefined);
        if (mapboxLayer.type === "circle") {
            mapboxLayer.metadata = this.metadata;
            this.mapboxLayer.addLayer(mapboxLayer, this.baseLayerId);
        }
    }

    protected addLocalSource(): void {
        this.mapboxLayer.addSource();
    }

    public updateLocalSource(source: Feature<Point>[]): void {
        this.mapboxLayer.updateSource(source);
    }

    public removeLayer(): void {
        this.mapboxLayer.removeLayer();
    }

    public removeLocalSource(): void {
        this.mapboxLayer.removeSource();
    }

    protected updateStyle(): void {
        throw new Error("Method not implemented.");
    }

    protected hideLayer(): void {
        this.mapboxLayer.hideLayer();
    }

    protected showLayer(): void {
        this.mapboxLayer.showLayer();
    }

    public updateMapOrder(): void {
        this.mapboxLayer.updateMapOrder(this.baseLayerId);
    }

    protected updateMapLevel(): void {
        throw new Error("Method not implemented.");
    }

    public getLayerIdsForSnapping(): string[] {
        throw new Error("Method not implemented.");
    }
}
